function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import { Placeholder, PlaceholderLine, PlaceholderMedia, Fade, ShineOverlay } from 'rn-placeholder';
import { stylePropTypes } from '@dkrm/general-libs/theme/styles';
const K_ANIMATION_BY_NAME = {
  fade: Fade,
  shine: ShineOverlay
};
export const Rectangle = ({
  height,
  style,
  noMargin,
  ...props
}) => {
  const borderRadius = 4;
  const marginBottom = 15;
  const computedStyle = {
    height,
    borderRadius,
    marginBottom
  };
  return /*#__PURE__*/React.createElement(PlaceholderLine, _extends({
    style: [computedStyle, style]
  }, props));
};
Rectangle.displayName = "Rectangle";
Rectangle.propTypes = process.env.NODE_ENV !== "production" ? {
  height: PropTypes.number,
  style: stylePropTypes,
  noMargin: PropTypes.bool
} : {};
Rectangle.defaultProps = {
  height: 15,
  style: {},
  noMargin: false
};
export const Circle = props => /*#__PURE__*/React.createElement(PlaceholderMedia, _extends({
  isRound: true
}, props));
const DeferredContent = props => {
  const {
    renderContent,
    renderSkeleton,
    isLoading,
    animation,
    ...rest
  } = props;
  if (!isLoading) return renderContent();
  return /*#__PURE__*/React.createElement(Placeholder, _extends({
    Animation: K_ANIMATION_BY_NAME[animation]
  }, rest), renderSkeleton());
};
DeferredContent.displayName = "DeferredContent";
DeferredContent.propTypes = process.env.NODE_ENV !== "production" ? {
  isLoading: PropTypes.bool.isRequired,
  renderContent: PropTypes.func.isRequired,
  renderSkeleton: PropTypes.func.isRequired,
  animation: PropTypes.oneOf(['fade', 'shine'])
} : {};
DeferredContent.defaultProps = {
  animation: 'shine'
};
export default DeferredContent;